import { useCallback } from "react";
import { generatePath, useNavigate } from "react-router";

import type { Room } from "@/lib/gql/__generated__/graphql";

import type { DnDResultItem } from "@/hooks/use-dnd/use-dnd";

import { PATHS } from "@/routes/paths";

import { TableRow } from "@/components/ui/table/table";

import { RoomListPageTableItem } from "./item";

type Props = { hotelID: string; room: DnDResultItem<Room>; onDeleteRoom: (roomID: string) => void; isSorting: boolean };

export const RoomListPageTableSortableItem = ({ hotelID, room, onDeleteRoom, isSorting }: Props) => {
	const navigate = useNavigate();
	const onTransitionToEdit = useCallback(() => {
		const editRoomPagePath = generatePath(PATHS.HOTEL.ITEMS.ROOM.EDIT.ROOM_ID.DEFAULT, {
			hotelID,
			roomID: room.value.roomID,
		});
		navigate(editRoomPagePath);
	}, [hotelID, navigate, room.value.roomID]);

	const handleClick = useCallback(() => {
		if (isSorting) return;
		onTransitionToEdit();
	}, [isSorting, onTransitionToEdit]);

	const { value } = room;

	return (
		<TableRow
			key={room.key}
			className="select-none gap-x-4 rounded bg-white hover:cursor-pointer"
			ref={isSorting ? room.events.ref : undefined}
			onMouseDown={isSorting ? room.events.onMouseDown : undefined}
			onClick={handleClick}
		>
			<RoomListPageTableItem hotelID={hotelID} room={value} onDeleteRoom={onDeleteRoom} isSorting={isSorting} />
		</TableRow>
	);
};
